{
	"download": "Télécharger",
	"editMassProduct": "Édition de produits en série",
	"label": "Nom du fichier",
	"products": "Produits",
	"selectDisclaimer": "Téléchargez les produits sélectionnés dans Excel et modifiez-les. Téléchargez ensuite le fichier pour mettre à jour votre menu.",
	"sheet": {
		"category": "Catégorie",
		"description": "Description",
		"filename": "éditer-produits-en-livraison-de-masse",
		"id": "IDENTIFIER (NE PAS MODIFIER)",
		"invalidFormat": "Format invalide",
		"name": "Nom",
		"price": "Prix",
		"sku": "SKU"
	},
	"xlsxDisclaimer": "Maintenant que vous avez édité les produits dans Excel, téléchargez le fichier et votre liste de produits sera mise à jour dans ce menu."
}
